import React, { useEffect } from 'react';
import * as tags from './_overlay_menu.tags';
import { SECTION_IDS } from '~/constants';
import closeIcon from '~/assets/header/close_button.svg';
import headerRerootsLogoWhite from '~/assets/header/reroots_logo_white.svg';
import { Link } from 'gatsby';

type Props = {
  readonly isVisible: boolean;
  readonly onCloseButtonClick: () => void;
};

export const OverlayMenu: React.FC<Props> = ({
  isVisible,
  onCloseButtonClick,
}) => {
  return (
    <tags.OverlayMenuWrapper visible={isVisible} onClick={onCloseButtonClick}>
      <tags.OverlayHeaderWrapper>
        <tags.NavContainer>
          <tags.CloseButton onClick={onCloseButtonClick}>
            <tags.CloseButtonIcon src={closeIcon} alt="メニュー" />
          </tags.CloseButton>
          <Link to={`#${SECTION_IDS.TOP}`} onClick={onCloseButtonClick}>
            <tags.RerootsLogo>
              <tags.RerootsLogoIcon
                src={headerRerootsLogoWhite}
                alt="Re roots"
              />
            </tags.RerootsLogo>
          </Link>
        </tags.NavContainer>
        <Link
          to={`/#${SECTION_IDS.CONTACT}`}
          style={{ textDecoration: 'none' }}
          onClick={onCloseButtonClick}
        >
          <tags.Contact>
            <tags.ContactText>CONTACT</tags.ContactText>
          </tags.Contact>
        </Link>
      </tags.OverlayHeaderWrapper>
      <tags.MenuContainer>
        <tags.MenuItemBox>
          <Link
            to={`/#${SECTION_IDS.TOP}`}
            style={{ textDecoration: 'none', display: 'block' }}
            onClick={onCloseButtonClick}
          >
            <tags.MenuItem>TOP</tags.MenuItem>
          </Link>
        </tags.MenuItemBox>
        <tags.MenuItemBox>
          <Link
            to={`/#${SECTION_IDS.DIGITAL}`}
            style={{ textDecoration: 'none', display: 'block' }}
            onClick={onCloseButtonClick}
          >
            <tags.MenuItem>デジタルプロモーション事業</tags.MenuItem>
          </Link>
        </tags.MenuItemBox>
        <tags.MenuItemBox>
          <Link
            to={`/#${SECTION_IDS.MEDIA}`}
            style={{ textDecoration: 'none', display: 'block' }}
            onClick={onCloseButtonClick}
          >
            <tags.MenuItem>メディア事業</tags.MenuItem>
          </Link>
        </tags.MenuItemBox>
        <tags.MenuItemBox>
          <Link
            to={`/#${SECTION_IDS.CASE}`}
            style={{ textDecoration: 'none', display: 'block' }}
            onClick={onCloseButtonClick}
          >
            <tags.MenuItem>実績事例</tags.MenuItem>
          </Link>
        </tags.MenuItemBox>
        <tags.MenuItemBox>
          <Link
            to={`/#${SECTION_IDS.RECRUIT}`}
            style={{ textDecoration: 'none', display: 'block' }}
            onClick={onCloseButtonClick}
          >
            <tags.MenuItem>採用情報</tags.MenuItem>
          </Link>
        </tags.MenuItemBox>
        <tags.MenuItemBox>
          <Link
            to={`/#${SECTION_IDS.COMPANY}`}
            style={{ textDecoration: 'none', display: 'block' }}
            onClick={onCloseButtonClick}
          >
            <tags.MenuItem>企業情報</tags.MenuItem>
          </Link>
        </tags.MenuItemBox>
      </tags.MenuContainer>
    </tags.OverlayMenuWrapper>
  );
};
